import React, { useEffect, useState } from 'react';
import CommonModal from "../../../../components/common/commonModal/CommonModal.jsx";
import { WALLET_CUSTODY_TYPE } from '../../../../constants/wallet.constants';
import { getLinkedWalletRowKey, normalizeLinkedCoinSymbol } from '../../../../services/wallet/linkedWallet.utils';
import { getWalletProviderIcon } from './walletProviderIcons';
import './SelectWalletModal.scss';
const SelectWalletModal = ({
  show,
  onClose,
  wallets = [],
  loading = false,
  onSelectWallet,
  selectingWalletId = null,
  paymentAssetLabel = '',
  orderSideLabel = ''
}) => {
  const [pendingWalletId, setPendingWalletId] = useState(null);
  const [errorMessage, setErrorMessage] = useState('');
  useEffect(() => {
    if (!show) {
      setErrorMessage('');
      setPendingWalletId(null);
    }
  }, [show]);
  const handleSelect = async wallet => {
    if (!wallet || selectingWalletId || pendingWalletId) return;
    setPendingWalletId(wallet.walletId);
    setErrorMessage('');
    try {
      await onSelectWallet(wallet);
      onClose();
    } catch (error) {
      setErrorMessage(error?.message || 'Failed to connect wallet. Please try again.');
    } finally {
      setPendingWalletId(null);
    }
  };
  const activeSelectingId = selectingWalletId ?? pendingWalletId;
  return <CommonModal show={show} handleClose={onClose} heading="Select Wallet" className="SelectWalletModal" backdrop="static">
      <div className="selectWalletModal">
        {loading ? <p className="selectWalletModal__status">Loading linked wallets...</p> : null}

        {!loading && wallets.length === 0 ? <p className="selectWalletModal__status">
            No linked wallets are available for this trading pair.
          </p> : null}

        <div className="selectWalletModal__list">
          {wallets.map(wallet => {
          const isSelecting = activeSelectingId === wallet.walletId;
          const custodyClass = wallet.custodyType === WALLET_CUSTODY_TYPE.NON_CUSTODIAL ? 'noncustodial' : 'custodial';
          const providerIcon = getWalletProviderIcon(wallet);
          return <button key={getLinkedWalletRowKey(wallet)} type="button" className="selectWalletModal__row wallet-row" onClick={() => handleSelect(wallet)} disabled={Boolean(activeSelectingId)}>
                <div className="wallet-row__main wr-main">
                  <div className="wallet-row__name wr-name">
                    <span>{wallet.walletName}</span>
                    <span className={`type-badge ${custodyClass}`}>
                      {providerIcon ? <img src={providerIcon} alt="" className="type-badge__icon" /> : null}
                      {wallet.walletTypeLabel}
                    </span>
                  </div>
                  <div className="wallet-row__sub wr-sub">{wallet.walletLabel}</div>
                  {wallet.coinName ? <div className="wallet-row__sub wr-sub wallet-row__payAsset">
                      Pays with{' '}
                      {(normalizeLinkedCoinSymbol(wallet.coinName) || wallet.coinName).toUpperCase()}
                    </div> : null}
                  <div className="wallet-row__sub wr-sub">{wallet.shortAddress}</div>
                </div>
                <div className="wallet-row__action">
                  {isSelecting ? 'Connecting...' : 'Select'}
                </div>
              </button>;
        })}
        </div>

        {errorMessage ? <div className="selectWalletModal__error" role="alert">
            <span className="selectWalletModal__errorText">{errorMessage}</span>
          </div> : null}
      </div>
    </CommonModal>;
};
export default SelectWalletModal;